import { render, staticRenderFns } from "./FullWidthContainer.vue?vue&type=template&id=52e8f714"
import script from "./FullWidthContainer.vue?vue&type=script&lang=js"
export * from "./FullWidthContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports